import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { API_URL } from '../../config';
import { showToast } from '../../components/toast';
import LoadingSpinner from "../../components/LoadingSpinner";

const DemoSalary = () => {
  const navigate = useNavigate();
  const mainPage = "/Payroll/SetSalary/list";
  const managePage = "Demo Salary";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  
  const toastShownRef = useRef(false); // ✅ Prevent duplicate toast

  const moneyFormatIndia = (num) => {
    if (!num) return "0.00";
    const numStr = parseFloat(num).toFixed(2);
    const parts = numStr.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const fetchDemoData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${API_URL}payroll/demo/salary`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === 1) {
        setData(response.data.data || []);

        // ✅ Only show toast if not already shown
        if (!toastShownRef.current) {
          showToast.success(response.data.message);
          toastShownRef.current = true;
        }

      } else {
        setError(response.data.message || "Failed to fetch demo data");
        showToast.error(response.data.message || "Failed to fetch demo data");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "An error occurred while fetching data";
      setError(errorMessage);
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDemoData();
  }, [token]);

  // Loading state
  if (loading) {
    return <LoadingSpinner />;
  }

  // Error state
  if (error) {
    return (
      <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
        <div id="content" className="">
          <div className="row pb-2">
            <div className="col-md-6">
              <h4 className="panel-title pull-left">{managePage}</h4>
            </div>
            <div className="col-md-6" style={{ textAlign: "right" }}>
              <button 
                onClick={() => navigate(mainPage)} 
                className="btn btn-default btn-sm"
              >
                <b><FontAwesomeIcon icon={faChevronLeft} /></b> Return to Set Salary
              </button>
            </div>
          </div>
          <div className="panel panel-default with-rounded-corner with-shadow">
            <div className="text-center p-4">
              <div className="alert alert-danger">
                <strong>Error:</strong> {error}
              </div>
              <button 
                onClick={fetchDemoData} 
                className="btn btn-primary btn-sm"
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      {/* Header would be included here from your layout */}
      
      <div id="content" className="">
        {/* Alert box component would go here */}
        
        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title pull-left">
              {managePage}
            </h4>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <button 
              onClick={() => navigate(mainPage)} 
              className="btn btn-default btn-sm"
            >
              <b><FontAwesomeIcon icon={faChevronLeft} /></b> Return to Set Salary
            </button>
            {/* <button 
              onClick={fetchDemoData} 
              className="btn btn-success btn-sm ms-2"
              disabled={loading}
            >
              {loading ? "Refreshing..." : "Refresh Data"}
            </button> */}
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Title</th>
                  <th>Value</th>
                </tr>
              </thead>
              {data && data.length > 0 ? (
                <tbody>
                  {data.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td> 
                          ₹ {moneyFormatIndia(item.formula_value)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="5" className="text-center">
                      <div className="p-4">
                        <i className="fa fa-info-circle fa-2x text-muted mb-2"></i>
                        <p className="text-muted">No demo data available</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>

        {/* Scroll to top button */}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default DemoSalary;
